<!--login-->

<!-- Bootstrap 5 Login Card -->
<div class="d-flex justify-content-center align-items-center vh-100 bg-light">
  <div class="card shadow-sm text-dark bg-light" style="width: 22rem">
    <div class="card-body">
      <h5 class="card-title text-center mb-4 text-secondary">Acceso</h5>

      <form (ngSubmit)="onSubmit(loginForm)" #loginForm="ngForm">
        <!-- Usuario -->
        <div class="mb-3">
          <label for="usuario" class="form-label text-muted">Usuario</label>
          <input
            type="text"
            class="form-control"
            id="usuario"
            name="username"
            [(ngModel)]="username"
            placeholder="Ingrese su usuario"
            required
          />
        </div>

        <!-- Contraseña con ícono -->
        <div class="mb-3">
          <label for="password" class="form-label text-muted">Contraseña</label>
          <div class="input-group">
            <input
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              id="password"
              name="password"
              [(ngModel)]="password"
              placeholder="Ingrese su contraseña"
              required
            />
            <button
              type="button"
              class="bg-transparent border-0"
              (click)="togglePasswordVisibility()"
              tabindex="-1"
            >
              <i class="bi" [ngClass]="showPassword ? 'bi-eye' : 'bi-eye-slash'"></i>
            </button>
          </div>
        </div>

        <!-- Error -->
        <div *ngIf="errorMessage" class="alert alert-danger py-1 text-center">
          {{ errorMessage }}
        </div>

        <!-- Botón -->
        <div class="d-grid">
          <button type="submit" class="btn btn-secondary">Ingresar</button>
        </div>
      </form>
    </div>
  </div>
</div>
